import { 
     PLATFORM_ID,
     Inject,
     Component,
     OnInit,
     ChangeDetectionStrategy,
     ChangeDetectorRef,
     AfterViewChecked,
     AfterViewInit,
     QueryList,
     ViewChild,
     Input,
     EventEmitter,
     HostListener,
     OnDestroy,
     ElementRef
     
 } from '@angular/core';

import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/fromEvent';

@Component({
    selector: "category-filter",
    templateUrl: "category-filter.template.html",
    styleUrls: ['category-filter.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
 export class CategoryFilter{
    @Input() category : string;
    @Input() title: string;
    @ViewChild('input') box : ElementRef;
    private isServer = false;
    private selected : Subscription;
    constructor(
        @Inject(PLATFORM_ID) platformId: string,
        private eventInteraction: EventInteraction,
        private cd : ChangeDetectorRef
    ){
         this.isServer = isPlatformServer(platformId); 
    }
    
    ngOnInit(){}
    
    private success(val){
            this.eventInteraction.next({key: "filterSelected", message:  {title: this.title,event:val}});
    }

    ngAfterViewInit(){
        if(this.box && !this.isServer){
            this.selected = Observable.fromEvent(this.box.nativeElement, 'change')
                .subscribe((val) => this.success(val));
        }
    }

    ngOnDestroy(){
        if ( this.selected ){
            this.selected.unsubscribe();
        }
    }
 }


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/search/category-filter/category-filter.component.ts